/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
// Utils
import { getFrom, isObject, joinPaths } from 'ezyvet-fe-helpers';
import { addObjectPropertiesChanges } from './addObjectPropertiesChanges';
/**
 * Detects the value type and decides how to continue deriving and adding changes, building array
 * changes by encoding objects.
 *
 * @template T extends (object | any[])
 * @param {T} value
 * @param {string} path
 * @param {ChangeList} changes
 *
 * @return {void}
 */
export var addChangesForValue = function (value, path, changes) {
    var newValue = getFrom(value, path);
    if (Array.isArray(newValue)) {
        newValue.forEach(function (subItem, index) {
            addChangesForValue(value, joinPaths(path, index.toString()), changes);
        });
    }
    else if (isObject(newValue)) {
        addObjectPropertiesChanges(newValue, changes);
    }
};
//# sourceMappingURL=addChangesForValue.js.map